import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHConvenioGet = async (credentials, data) => {
  const body = {
    service: "RNHConvenioGet",
    params: {
      rnhConvenioId: data?.id || null,
      rnhConvenioCod: data?.cod || null,
      rnhConvenioLey: data?.ley || null,
      rnhConvenioCargaSemanal: data?.cargaSemanal || null,
      page: data?.page ?? null,
      pageSize: data?.pageSize ?? null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
